module.exports = __webpack_public_path__ + "static/media/arrow_down.21acd24b.svg";